import {Dispatch, PropsWithChildren, useMemo, useReducer} from "react";
import {
  getStoreServicesOrdersFormReducer,
  GetStoreServicesOrdersReducerActions,
  initialGetStoreServicesOrdersReducerState,
} from "../reducers";
import {createContext} from "../../../../context/create-context";
import {GetStoreServicesOrdersApiResponse} from "../../../../react-query-hooks/store/services/get-orders/types";
import {PaginationMeta} from "../../../../redux/service/i-service";
import {useGetStoreServicesOrders} from "../../../../react-query-hooks/store/services/get-orders";

type GetStoreServicesOrdersContextState = {
  state: typeof initialGetStoreServicesOrdersReducerState;
  dispatch: Dispatch<GetStoreServicesOrdersReducerActions>;
  orders: GetStoreServicesOrdersApiResponse["orders"];
  paginationMeta: PaginationMeta | undefined;
  isLoading: boolean;
  isError: boolean;
  isPreviousData: boolean;
};

const [useContext, ContextProvider] = createContext<GetStoreServicesOrdersContextState>();

export const useGetStoreServicesOrdersContext = useContext;

export const GetStoreServicesOrdersContextProvider = ({children}: PropsWithChildren) => {
  const [state, dispatch] = useReducer(
    getStoreServicesOrdersFormReducer,
    initialGetStoreServicesOrdersReducerState
  );

  const {data, isLoading, isError, isPreviousData} = useGetStoreServicesOrders({
    statusId: state.statusId,
    page: state.currentPage,
    per_page: state.per_page,
  });

  const value = useMemo(() => {
    const orders = data?.data.orders ?? [];
    const paginationMeta = data?.meta;

    return {
      state,
      dispatch,
      orders,
      paginationMeta,
      isLoading,
      isError,
      isPreviousData,
    };
  }, [
    state,
    dispatch,
    data, // only depends on raw query data
    isLoading,
    isError,
    isPreviousData,
  ]);

  return <ContextProvider value={value}>{children}</ContextProvider>;
};
